<i class="d-none d-lg-inline fa fa-2x fa-caret-left"
   [ngClass]="{'suggestion-present': suggestionsPresent}"></i>
<i class="d-inline d-lg-none fa fa-2x fa-caret-up"></i>
<div class="error-message"
     [ngClass]="{'zero-left-margin': suggestionsPresent}">
  <p *ngFor="let msg of transformedMsgs"

     [ngClass]="{'big-text': msg.length >= 45}">{{msg}}</p>
</div>